import { Link } from "react-router-dom";
import { formatHot, getHotEntries } from "@/hooks/useSiteData";
import SectionHeading from "@/components/base/SectionHeading";

export default function HotRanking() {
  const top = getHotEntries(8);

  return (
    <section className="border-b border-background-200 bg-background-100/60 px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="本周热榜"
        title="热度前八的词条"
        desc="热度综合浏览量、收藏量与近期更新频率，每天更新一次。"
        linkText="完整榜单"
        linkTo="/ranking"
      />

      <ol className="grid grid-cols-1 gap-x-8 gap-y-1 md:grid-cols-2">
        {top.map((entry, index) => (
          <li key={entry.id}>
            <Link
              to={`/entry/${entry.id}`}
              className="group flex items-center gap-4 border-b border-background-200 py-3.5 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  index < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                  {entry.title}
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">
                  {entry.alias} · {entry.status}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-1 text-xs text-primary-700">
                <i className="ri-fire-line"></i>
                {formatHot(entry.hot)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}